import { useTranslation } from 'react-i18next';
import { useTheme, Stack, Icon, Typography } from '../../../../base';
import {
    IClientSourceOfHireEntry,
    formatSourceOfHireAmount,
} from '../../../../common';
import {
    StyledTop3Card,
    StyledIconCircle,
    StyledCardTitle,
    StyledRankList,
    StyledRankItem,
} from './Top3Section.styles';

interface ITop3CardProps {
    titleKey: string;
    isPercent: boolean;
    entries: IClientSourceOfHireEntry[];
}

const Top3Card = ({ titleKey, isPercent, entries }: ITop3CardProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <StyledTop3Card direction="row">
            <StyledIconCircle>
                <Icon
                    name="EmojiEventsOutlinedIcon"
                    size={24}
                    style={{ color: theme.palette.common.white }}
                />
            </StyledIconCircle>
            <Stack spacing={0.5} sx={{ minWidth: 0 }}>
                <StyledCardTitle variant="caption">
                    {t('reportsPage.sourceOfHireReport.top3Prefix')}{' '}
                    {t(titleKey)}
                </StyledCardTitle>
                <StyledRankList component="ol">
                    {entries.map((entry, index) => (
                        <StyledRankItem
                            component="li"
                            direction="row"
                            key={entry.sourceTitle}
                        >
                            <Typography
                                variant="body2"
                                component="span"
                                sx={{ fontWeight: 700 }}
                            >
                                {index + 1}. {entry.sourceTitle} (
                                {formatSourceOfHireAmount(
                                    entry.amount,
                                    isPercent
                                )}
                                )
                            </Typography>
                        </StyledRankItem>
                    ))}
                </StyledRankList>
            </Stack>
        </StyledTop3Card>
    );
};

export default Top3Card;
